import { render, staticRenderFns } from "./groupList.vue?vue&type=template&id=12c502bc&scoped=true&"
import script from "./groupList.vue?vue&type=script&lang=js&"
export * from "./groupList.vue?vue&type=script&lang=js&"
import style0 from "./groupList.vue?vue&type=style&index=0&id=12c502bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c502bc",
  null
  
)

export default component.exports